/* src/app/shared/components/app-notifications-content/app-notifications-content.component.scss */
::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}
::-webkit-scrollbar-thumb {
  background: #acacac;
  border-radius: 8px;
}
::-webkit-scrollbar-track {
}
body {
  scrollbar-face-color: #acacac;
  scrollbar-track-color: rgb(213.5, 213.5, 213.5);
}
section {
  width: 99% !important;
}
.notification-header {
  font-weight: bold;
  color: #111111;
  margin-bottom: 5px;
  margin-top: 5px;
}
.notification-container {
  padding-bottom: 10px !important;
}
.notification_none {
  padding-top: 100px;
  font-weight: bold;
  display: flex;
  justify-content: center;
}
.notification-card {
  border-radius: 5px !important;
  height: auto;
  width: 100% !important;
}
.notification-card-active {
  background: #F1F7FB 0% 0% no-repeat padding-box;
  border: 1px solid #A2D5FF;
}
.notification-card-active:hover {
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137) !important;
}
.notification-card-notactive {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 1px solid #D5D5D5;
}
.notification-card-notactive:hover {
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137) !important;
}
.notification-type {
  margin-top: 5px;
  color: #4A4A4A;
  padding-bottom: 0.4rem;
}
.notification-type-active {
  font-weight: bold;
}
.notification-type-notactive {
  font-weight: normal;
}
.divider {
  margin: 0px 5px 0px 5px;
  margin-bottom: 0;
}
.view-shared-btn {
  height: 24px;
  padding: 2px 8px;
  font-size: 12px;
}
:host::ng-deep .mat-mdc-card-content:last-child {
  padding-bottom: 0px !important;
}
/*# sourceMappingURL=app-notifications-content.component.css.map */
